import {
    GET_K_AUDIENCES_SESSIONS_CHARTS_DATA,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
    GET_K_STORE_VISITS_DATA,
    GET_USER_GROWTH_DATA,
} from "./actionType";

export const getKAudiencesSessionsChartsData = (periodType) => ({
    type: GET_K_AUDIENCES_SESSIONS_CHARTS_DATA,
    payload: periodType
});

export const getKStoreVisitsData = () => ({
    type: GET_K_STORE_VISITS_DATA
});

export const getUserGrowth = (timeRange) => ({
    type: GET_USER_GROWTH_DATA,
    payload: { timeRange }
});

export const dashboardApiResponseSuccess = (actionType, data) => {
    console.log("Action creator - success:", { actionType, data });
    return {
        type: API_RESPONSE_SUCCESS,
        payload: { actionType, data }
    };
};

export const dashboardApiResponseError = (actionType, error) => {
    console.log("Action creator - error:", { actionType, error });
    return {
        type: API_RESPONSE_ERROR,
        payload: { actionType, error }
    };
}; 